import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import api from "../lib/api";
import { Logo } from "../components/Logo";
import NoIndex from "../components/NoIndex";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <NoIndex />
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center">
          <Logo className="h-8" />
        </div>
        {sent ? (
          <div className="text-center" data-testid="forgot-password-sent">
            <MailCheck className="mx-auto h-10 w-10 text-primary" />
            <h1 className="mt-4 font-heading text-xl font-bold">Check your email</h1>
            <p className="mt-1 text-sm text-muted-foreground">If an account exists for {email}, a reset link has been sent.</p>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-bold tracking-tight">Forgot password?</h1>
            <p className="mt-1 text-sm text-muted-foreground">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <Input
                type="email"
                required
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-password-email-input"
              />
              <Button type="submit" disabled={loading} className="w-full" data-testid="forgot-password-submit-btn">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Reset Link"}
              </Button>
            </form>
          </>
        )}
        <p className="mt-6 text-center text-sm text-muted-foreground">
          <Link to="/login" className="font-medium text-primary hover:underline" data-testid="back-to-login-link">
            Back to login
          </Link>
        </p>
      </div>
    </div>
  );
}
